import { useContext } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoMdArrowForward } from "react-icons/io";
import { AppContext } from "../App";
import heroImage from "../assets/banner1.jpg";
import cardImage from "../assets/banner3.jpg";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);

  return (
    <section className="appdev-hero">
      <div className="container position-relative appdev-hero__content">
        <div className="row align-items-center g-5 min-vh-100 py-5">
          <div className="col-lg-7">
            <div className="appdev-hero__badge mb-3">SYSTEM ARCHITECTS</div>
            <h1 className="appdev-hero__title mb-4">
              Werenium <br />
              <span className="appdev-hero__gradient">Application Development</span>
            </h1>
            <p className="appdev-hero__lead mb-5">
              We engineer high-concurrency systems and scalable mobile applications
              designed to automate complexity and drive measurable growth.
            </p>
            <div className="d-flex flex-wrap gap-3">
              <button
                className="appdev-hero__button"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                Start a Project <IoMdArrowForward size={20} />
              </button>
            </div>
          </div>

          <div className="col-lg-5">
            <FeatureCard />
          </div>
        </div>
      </div>

      <style>{`
        .appdev-hero {
          position: relative;
          background: #12121c;
          background-image: linear-gradient(rgba(18, 18, 28, 0.85), rgba(18, 18, 28, 0.95)), url(${heroImage});
          background-size: cover;
          background-position: center;
          overflow: hidden;
        }

        .appdev-hero__content {
          z-index: 2;
        }

        .appdev-hero__gradient {
          background: linear-gradient(90deg, #e88a1c, #ffb35c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .appdev-hero__badge {
          display: inline-block;
          padding: 6px 16px;
          background: rgba(232, 138, 28, 0.1);
          border: 1px solid rgba(232, 138, 28, 0.3);
          color: #e88a1c;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 2px;
          border-radius: 2px;
        }

        .appdev-hero__title {
          font-size: clamp(2.5rem, 6vw, 4.2rem);
          font-weight: 800;
          color: #ffffff;
          line-height: 1;
          letter-spacing: -0.04em;
        }

        .appdev-hero__lead {
          font-size: 1.15rem;
          color: rgba(255, 255, 255, 0.7);
          max-width: 580px;
          line-height: 1.6;
        }

        .appdev-hero__button {
          padding: 16px 32px;
          background: #e88a1c;
          color: #fff;
          border: none;
          font-weight: 700;
          border-radius: 4px;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: all 0.3s ease;
          text-transform: uppercase;
          font-size: 0.9rem;
          letter-spacing: 1px;
        }

        .appdev-hero__button:hover {
          background: #cf7610;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(232, 138, 28, 0.3);
        }

        .appdev-hero-card {
          background: #1a1a2e;
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 8px;
          padding: 40px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 40px 80px rgba(0, 0, 0, 0.5);
        }

        .appdev-hero-card__image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: url(${cardImage});
          background-size: cover;
          opacity: 0.15;
          z-index: 0;
        }

        .appdev-hero-card__content {
          position: relative;
          z-index: 1;
        }

        .appdev-hero-card__kicker {
          color: #e88a1c;
          font-weight: 700;
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 10px;
          display: block;
        }

        .appdev-hero-card__title {
          font-size: 1.75rem;
          font-weight: 800;
          color: #fff;
          margin-bottom: 25px;
          letter-spacing: -0.02em;
        }

        .appdev-hero-card__list {
          list-style: none;
          padding: 0;
          margin-bottom: 35px;
        }

        .appdev-hero-card__item {
          display: flex;
          align-items: center;
          gap: 15px;
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 16px;
          font-size: 0.95rem;
        }

        .appdev-hero-card__dot {
          width: 6px;
          height: 6px;
          background: #e88a1c;
          border-radius: 50%;
        }

        .appdev-hero-card__whatsapp {
          width: 100%;
          padding: 14px;
          background: transparent;
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border-radius: 4px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .appdev-hero-card__whatsapp:hover {
          background: #25d366;
          border-color: #25d366;
          color: #fff;
        }
      `}</style>
    </section>
  );
}

function FeatureCard() {
  const features = [
    "Business-first app architecture",
    "Fast, secure, and maintainable code",
    "Smooth deployment with zero guesswork",
  ];

  return (
    <div className="appdev-hero-card">
      <div className="appdev-hero-card__image" />
      <div className="appdev-hero-card__content">
        <span className="appdev-hero-card__kicker">Deployment Ready</span>
        <h3 className="appdev-hero-card__title">Ship Faster. Scale Smarter.</h3>

        <ul className="appdev-hero-card__list">
          {features.map((item, index) => (
            <li key={index} className="appdev-hero-card__item">
              <div className="appdev-hero-card__dot" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <a
          className="appdev-hero-card__whatsapp"
          href="https://wa.me/255758779913?text=Hi%20Werenium%2C%20I%20want%20to%20build%20a%20new%20application."
          target="_blank"
          rel="noreferrer"
        >
          <FaWhatsapp size={20} />
          Consult on WhatsApp
        </a>
      </div>
    </div>
  );
}
